import React, { useState } from 'react'
import { Typography, TextField } from '@material-ui/core'
import PropTypes from 'prop-types'
import axios from 'axios'
import { useStyles } from '../styles'
// components
import Dialog from '../../../../../components/Dialog'


export default function JobCityFormDlg(props) {

	console.log(props.country)

	const classes = useStyles()
	const [err, setErr] = useState('')
	const [cityName , setCityName] = useState(null)

	const saveFunction = async () => {
		setErr('')

		if(!cityName) {
			setErr('Enter City Name')
			return
		}

		const payload = {
			name: cityName,
			country_id: props.country.value,
		}

		try {
			const res = await axios.post(`/api/cities`, payload)
			const newCity = res.data.data
            props.onSuccess({value: newCity.id, label: newCity.name})
        } catch(e) {
            setErr('Sorry, we are unable to add city')
        }
	}

	return (
		<Dialog
			size={'sm'}
			title={`Add New City To ${props.country.label}`}
			isOpen={props.isOpen}
			onClose={() => props.onClose()}
			actions={[
				{
					title: 'Cancel',
					func: () => {
						props.onClose()
					},
				},
				{
					title: 'Add',
					func: async () => {
						await saveFunction()
					},
				},
			]}
		>
			<div className={classes.textSelectionArea}>
				{
					err ?
						<Typography>{err}</Typography>
						:
						null
				}
				<TextField
					required
					label="City Name"
					className={classes.textArea}
					margin="normal"
					onChange={(e) => setCityName(e.target.value)}
				/>
			</div>
		</Dialog>
	)
}

JobCityFormDlg.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSuccess: PropTypes.func.isRequired,
}
